// Human-maintained log shown on the About page. Newest entry first.
// After code changes: run `npm run bump-version && npm run write-version`, then add a
// block here whose `version` matches `APP_VERSION` in src/version.js (from package.json).

export const ABOUT_CHANGELOG = [
  {
    version: "2.0.521",
    date: "2026-10-10",
    items: [
      "Player: rejoining after the question's timer had already ended could still overwrite the team's answer with a blank. Auto-submit now skips any question the rejoin restored as answered.",
    ],
  },
  {
    version: "2.0.519",
    date: "2026-10-10",
    items: [
      "Host, Pricing, Account and quiz editor: confirmations and messages now appear as Quizmaster's own on-page dialog instead of browser pop-ups. Fixes Host Quiz doing nothing in browsers that block pop-ups (the 'spend 1 token?' prompt was auto-cancelled).",
    ],
  },
  {
    version: "2.0.517",
    date: "2026-10-10",
    items: [
      "Host quiz list: smaller, consistent action buttons with icons, gradient, hover lift and clear disabled state; Host Quiz is the main (larger) button.",
    ],
  },
  {
    version: "2.0.513",
    date: "2026-10-10",
    items: [
      "Host quiz list: the button bar wraps on narrower windows and the list leaves room for it — Host Quiz was being pushed off the edge of the screen.",
    ],
  },
  {
    version: "2.0.512",
    date: "2026-10-10",
    items: [
      "Speed Test mode (automated tests only): post-question pause 6 s so scoring always runs before the next slide.",
    ],
  },
  {
    version: "2.0.511",
    date: "2026-10-10",
    items: [
      "Player app (iOS/Android): #TeamChoice round picker now works in the native app — the session is polled via REST and the pick is saved with a safe one-time update (the Firestore SDK never responds inside the app).",
      "Host: Speed Test mode for automated tests (short pauses between slides); only switched on by the test suite.",
    ],
  },
  {
    version: "2.0.510",
    date: "2026-10-10",
    items: [
      "Hosting: pages are no longer cached for an hour, so hosts get fixes as soon as they're deployed (images and code files are still cached).",
    ],
  },
  {
    version: "2.0.509",
    date: "2026-10-10",
    items: [
      "Player app (iOS/Android): BETANSWER bets were never saved in the native app, so phone teams always scored 0 on bet questions. Bets now save via a field-only update.",
    ],
  },
  {
    version: "2.0.508",
    date: "2026-10-10",
    items: [
      "Host scoring: BREADCRUMBS questions awarded no points to anyone when any team answered wrong (an empty field made the whole scoring save fail). Fixed.",
    ],
  },
  {
    version: "2.0.507",
    date: "2026-10-10",
    items: [
      "Player: TRUE/FALSE taps could be recorded as the opposite answer (the screen always shows FALSE then TRUE, but the shuffle was used to save). Display, scoring, saving and rejoin now share one order.",
      "Account page: shows \"… tokens\" while loading instead of briefly showing 0 tokens.",
    ],
  },
  {
    version: "2.0.506",
    date: "2026-10-10",
    items: [
      "Host quiz list is now a table with Quiz name / Owner / Questions headings; owner and question count sit in aligned columns.",
    ],
  },
  {
    version: "2.0.505",
    date: "2026-10-10",
    items: [
      "Host scoring: TRUE/FALSE questions could award points to the wrong answer (about half of hosted quizzes, depending on answer shuffle). Fixed — scored the same way as multiple choice.",
    ],
  },
  {
    version: "2.0.504",
    date: "2026-10-10",
    items: [
      "Host quiz list: each quiz now shows how many questions it has (not counting join, round and score slides).",
      "Host: the Test Mode 5-question limit message now appears once instead of repeating endlessly.",
      "Player app: \"Continue quiz\" now appears after the app is closed or crashes, so teams can rejoin in one tap.",
      "Player app: rejoining mid-question no longer overwrites the team's answer with a blank (lost points).",
      "Automated end-to-end tests (e2e/): host + Android app + web players play a real quiz; new \"E2E Test Quiz\" covers every question type.",
      "Android player app: first working build — updated to Capacitor 8 / Android 16 (API 36) as Google Play requires; signed release bundle (AAB) ready to upload.",
      "Android: app now stays clear of the status bar and gesture bar (Android 15+ edge-to-edge).",
      "Version script now syncs Android versionName/versionCode with iOS; GitHub Android build workflow fixed.",
    ],
  },
  {
    version: "2.0.502",
    date: "2026-08-06",
    items: [
      "Account/Pricing: fixed subscription detection (Stripe expand limit); shows active weekly plan and quantity instead of No weekly plan.",
    ],
  },
  {
    version: "2.0.501",
    date: "2026-08-06",
    items: [
      "Manage billing: Live Stripe Customer Portal configured; Account “Manage billing” opens Stripe to update payment method, invoices, and cancel/change subscription.",
    ],
  },
  {
    version: "2.0.500",
    date: "2026-08-06",
    items: [
      "Account page: cleaner host layout — subscription summary from Stripe, no seed-tokens or raw entitlements dump; token history at bottom and collapsed by default.",
    ],
  },
  {
    version: "2.0.499",
    date: "2026-08-06",
    items: [
      "Go-live checklist: professional public domain (prefer .com / .co.uk, not .com.au) required before soft launch; replace bobquiz-272a7.web.app.",
    ],
  },
  {
    version: "2.0.498",
    date: "2026-08-04",
    items: [
      "Stripe Live: Production billing uses Live keys + Live webhook; Pricing catalog £30/week and £40 one-off.",
      "Pricing: catalog shows correct amount for tiered Stripe weekly prices (was blank/£0).",
    ],
  },
  {
    version: "2.0.497",
    date: "2026-08-04",
    items: [
      "Pricing: soft-launch GBP-only catalog — weekly £30 and one-off £40; Pricing page defaults to pounds.",
    ],
  },
  {
    version: "2.0.496",
    date: "2026-08-04",
    items: [
      "Player join: removed green debug lookup printout that flashed after entering a join code.",
    ],
  },
  {
    version: "2.0.495",
    date: "2026-08-04",
    items: [
      "Player welcome splash: centered layout, Quizmaster Bob logo, title Welcome to Quizmaster Bob's trivia.",
    ],
  },
  {
    version: "2.0.494",
    date: "2026-08-04",
    items: [
      "Player welcome splash: centered layout, Quizmaster Bob logo, copy Welcome to Quizmaster Bob's trivia.",
    ],
  },
  {
    version: "2.0.493",
    date: "2026-08-04",
    items: [
      "Player app: welcome splash (“Welcome to Quizmaster Bob”) before join-code; Continue quiz / rejoin surfaced on welcome and join screens.",
      "Stripe Test: GBP weekly volume tiers (£30…) plus GBP (£37.50) and AUD (A$61) one-off prices; Live mode prices still required for real cards.",
      "Go-live checklist: Pitch deferred; current focus Billing + Player apps.",
    ],
  },
  {
    version: "2.0.492",
    date: "2026-08-03",
    items: [
      "Go-live checklist reordered by recommended work sequence (Pitch → Live billing → Legal → Host UX → Player → feature verify → soft launch).",
    ],
  },
  {
    version: "2.0.491",
    date: "2026-08-03",
    items: [
      "Go-live checklist: player welcome/splash screen and front-screen continue/rejoin for crash recovery.",
    ],
  },
  {
    version: "2.0.490",
    date: "2026-08-03",
    items: [
      "Updated go-live checklist: App Store live confirmed; add Pitch page fix, Google Play, and verify/finish losing-team round theme choice (#TeamChoice).",
    ],
  },
  {
    version: "2.0.489",
    date: "2026-08-03",
    items: [
      "Release packaging for go-live checklist update (see 2.0.490).",
    ],
  },
  {
    version: "2.0.488",
    date: "2026-08-01",
    items: [
      "Removed automatic live-quiz token refunds — 1 token is spent when you host live and is kept; use Reconnect after a dropout (no extra charge).",
      "Reconnect lists only your own quizzes and only within 3 hours of start (Qwizard/admins see all quizzes with no time limit).",
    ],
  },
  {
    version: "2.0.487",
    date: "2026-08-01",
    items: [
      "Release packaging for refund removal and reconnect restrictions (see 2.0.488).",
    ],
  },
  {
    version: "2.0.486",
    date: "2026-07-31",
    items: [
      "Account token history: each row shows running balance after the change; date/time uses the viewer’s local timezone (not hard-coded Brisbane).",
    ],
  },
  {
    version: "2.0.485",
    date: "2026-07-31",
    items: [
      "Release packaging for Account token history balance/local-time update (see 2.0.486).",
    ],
  },
  {
    version: "2.0.484",
    date: "2026-07-26",
    items: [
      "Account: expandable Token history showing date/time, reason, and +/- for every spend, refund, purchase, and subscription credit.",
      "Fix: live-quiz token could be silently refunded after a full night because refund logic treated maxQuestionIndex=0 as “no progress” instead of using the real question position.",
      "Seed test tokens allowlist includes @izeus.org.",
    ],
  },
  {
    version: "2.0.483",
    date: "2026-07-26",
    items: [
      "Release packaging for Account token history and live-token refund fix (see 2.0.484).",
    ],
  },
  {
    version: "2.0.482",
    date: "2026-07-26",
    items: [
      "Fix: Test Mode no longer blocks forward/auto-advance after a few slides — the free limit counts playable quiz questions only (not join/intro/round markers).",
      "Advance lock always clears (try/finally); stale library-selection locks clear so hosts are not stuck unable to skip forward.",
    ],
  },
  {
    version: "2.0.481",
    date: "2026-07-26",
    items: [
      "Release packaging for Test Mode advance fix (see 2.0.482).",
    ],
  },
  {
    version: "2.0.480",
    date: "2026-07-26",
    items: [
      "Deployed host billing to Firebase: Firestore entitlement locks, token spend/refund/seed APIs, and updated hosting UI.",
    ],
  },
  {
    version: "2.0.478",
    date: "2026-07-23",
    items: [
      "Host billing: live quizzes (Test Mode Off) confirm and spend 1 quiz token; auto-refund if the session never gets past 5 questions.",
      "Test Mode: free practice capped at 5 questions, then an alert to switch to live hosting.",
      "Zero tokens blocks live host with a link to Pricing; create/edit/share quizzes stay free.",
      "Stripe one-off payments now credit quiz tokens; Account can seed 100 test tokens once for company emails; Pricing in the host menu.",
      "Firestore: clients can no longer write entitlements, stripeCustomers, payments, or token ledgers (Cloud Functions only).",
    ],
  },
  {
    version: "2.0.475",
    date: "2026-07-14",
    items: [
      "Support page contact email set to info@quizmasterbob.com.au (replaces placeholder support@quizmasterbob.com).",
      "Published privacy and support pages to Firebase Hosting so App Store / public URLs work: https://bobquiz-272a7.web.app/privacy and /support.",
    ],
  },
  {
    version: "2.0.472",
    date: "2026-05-28",
    items: [
      "iOS App Store prep: privacy and support pages (/privacy, /support), player footer links, iOS version sync with package.json, Release CI archive, optional TestFlight upload, and docs/ios-app-store-release.md checklist.",
      "iOS: ITSAppUsesNonExemptEncryption set for standard HTTPS-only export compliance.",
    ],
  },
  {
    version: "2.0.471",
    date: "2026-05-28",
    items: [
      "Player app: True/False and other answer pills use auto-fit text that shrinks to fit the pill; when marked (✓/✗), font recalculates with extra inset so TRUE/FALSE stays fully visible.",
    ],
  },
  {
    version: "2.0.470",
    date: "2026-05-28",
    items: [
      "Final Scores marquee: after 1st place scrolls off, four card-widths of plain background pass before last place appears again (no abrupt jump back to the bottom of the board).",
    ],
  },
  {
    version: "2.0.469",
    date: "2026-05-28",
    items: [
      "Score cards (per-question, round, and final): team names on a thin angled sash across the selfie with place-coloured gradients; nearest-answer “faster” teams get a ⚡ badge instead of a second band.",
      "Shared TeamNameSash component for consistent styling across all score screens.",
    ],
  },
  {
    version: "2.0.468",
    date: "2026-05-28",
    items: [
      "Vanishing choice: last vanish now completes before the final countdown segment, so only two options remain visible for the last interval (fixes three options still showing with one second left).",
    ],
  },
  {
    version: "2.0.467",
    date: "2026-05-28",
    items: [
      "Vanishing choice & timed questions: countdown now starts when the answers gate opens (after hero/TTS), not on question advance; host and player timers stay hidden until then.",
      "Vanishing choice: options vanish evenly over the full question time (no separate grace period); host and player stay in sync via the shared vanishing plan.",
    ],
  },
  {
    version: "2.0.466",
    date: "2026-05-28",
    items: [
      "Vanishing choice: schedule tied to full question duration (10s all visible, then even vanishes until two remain); host and player now derive visibility from the same countdown plan for sync.",
    ],
  },
  {
    version: "2.0.465",
    date: "2026-05-27",
    items: [
      "Player app: reserve bottom space for the fixed timer bar; 4+ answer pills use capped row heights so they no longer stretch under the timer.",
    ],
  },
  {
    version: "2.0.464",
    date: "2026-05-27",
    items: [
      "Player app: question box slightly wider (calc(100vw − 10px)); long questions use a smaller dynamic font, tighter line height, and less bottom margin so answer pills keep more room.",
    ],
  },
  {
    version: "2.0.463",
    date: "2026-05-27",
    items: [
      "Vanishing choice: tighter vanish timing plus safety snap to exactly two options when time runs out.",
      "Player app: answer pills flex to fit above the timer; question box wider (97vw), more transparent background.",
    ],
  },
  {
    version: "2.0.462",
    date: "2026-05-27",
    items: [
      "Vanishing choice: wrong answers now vanish at equal intervals based on countdown time left when answers appear (10s all visible, then one-by-one until exactly two remain).",
    ],
  },
  {
    version: "2.0.461",
    date: "2026-05-27",
    items: [
      "Player app: True/False answer pills now use the same width as multichoice options (86vw) instead of stretching full screen.",
    ],
  },
  {
    version: "2.0.460",
    date: "2026-05-27",
    items: [
      "Player lobby: “Waiting for Quizmaster to start the quiz” now sits in a matching pill directly below the welcome/question box (flows with dynamic question height).",
    ],
  },
  {
    version: "2.0.459",
    date: "2026-05-27",
    items: [
      "Player app: TYPE Submit button matches answer-pill size; bet panel uses transparent background and question font; questions moved down 3%.",
    ],
  },
  {
    version: "2.0.458",
    date: "2026-05-27",
    items: [
      "Player app: each answer pill independently sizes its text to ~50% of pill height (host ratio), shrinking only when needed to fit on one line.",
    ],
  },
  {
    version: "2.0.457",
    date: "2026-05-27",
    items: [
      "Player app: answer text now auto-shrinks to fit inside each pill so long options no longer overflow.",
    ],
  },
  {
    version: "2.0.456",
    date: "2026-05-27",
    items: [
      "Player app: larger answer-option text sized to match the host screen pill ratio (scales with viewport height).",
    ],
  },
  {
    version: "2.0.455",
    date: "2026-05-27",
    items: [
      "Player join screen: clearer message when an invalid or inactive join code is entered (no more SDK timeout error).",
    ],
  },
  {
    version: "2.0.454",
    date: "2026-05-27",
    items: [
      "Player team-selfie: compress photos to ~960px before upload (much faster; shows file size after selection).",
      "Upload overlay with animated spinner so users know the app is working.",
    ],
  },
  {
    version: "2.0.453",
    date: "2026-05-27",
    items: [
      "Player team-selfie upload (native iOS): uses Capacitor native HTTP for Firebase Storage uploads — fixes persistent “Load failed” in WKWebView.",
      "Enabled CapacitorHttp plugin so native network requests bypass broken WebView fetch.",
    ],
  },
  {
    version: "2.0.452",
    date: "2026-05-27",
    items: [
      "Player team-selfie upload (native app): restored Firebase REST upload path — fixes stuck “Uploading…” and “Load failed” regressions from v2.0.451.",
    ],
  },
  {
    version: "2.0.451",
    date: "2026-05-27",
    items: [
      "Player team-selfie upload: use Firebase Storage SDK on native iOS (fixes “Load failed” when joining).",
    ],
  },
  {
    version: "2.0.450",
    date: "2026-05-27",
    items: [
      "Player team-selfie upload: fixed “Load failed” on iOS by reading photos as Base64 instead of fetch(webPath).",
      "Team-selfie screen: added “or” between Take Photo and Choose Photo buttons.",
    ],
  },
  {
    version: "2.0.449",
    date: "2026-05-27",
    items: [
      "Player team-selfie screen: Join button is ghosted out and disabled until a photo is selected.",
    ],
  },
  {
    version: "2.0.448",
    date: "2026-05-27",
    items: [
      "Player team-selfie: Take Photo on iOS Simulator opens the photo library instead of showing a no-camera error.",
    ],
  },
  {
    version: "2.0.447",
    date: "2026-05-27",
    items: [
      "iOS: added NSPhotoLibraryAddUsageDescription privacy key so Take Photo and Choose Photo work in the native app.",
    ],
  },
  {
    version: "2.0.446",
    date: "2026-05-27",
    items: [
      "Player team-selfie screen: separate Take Photo and Choose Photo buttons; photo library works again without the generic “Choose File” option in the native app.",
      "Fixed Capacitor Camera native plugin install (iOS) so camera/photo picking works on device.",
      "Wizard step titles (team name + selfie) now share the same Montserrat title font.",
    ],
  },
  {
    version: "2.0.445",
    date: "2026-05-27",
    items: [
      "Player team-selfie picker: mobile app always uses native camera/photo library (no HTML “Choose File” option).",
    ],
  },
  {
    version: "2.0.444",
    date: "2026-05-27",
    items: [
      "Player team-selfie picker (native app): uses camera/photo library only — no generic “Choose File” option.",
      "Added @capacitor/camera with iOS privacy strings for camera and photo library access.",
    ],
  },
  {
    version: "2.0.443",
    date: "2026-05-27",
    items: [
      "Player team-selfie screen: brain background and white bold title (matches team-name step); removed gray card; green pill buttons.",
    ],
  },
  {
    version: "2.0.442",
    date: "2026-05-27",
    items: [
      "Player team-name field: input capped at 43 characters (same max as submit validation).",
    ],
  },
  {
    version: "2.0.441",
    date: "2026-05-27",
    items: [
      "Player team-name screen: title matches join-code screen (white bold text on brain background); removed white card.",
    ],
  },
  {
    version: "2.0.440",
    date: "2026-05-27",
    items: [
      "Player join screen: removed white card background so the brain image shows through; title and labels use light text on the background.",
    ],
  },
  {
    version: "2.0.439",
    date: "2026-05-27",
    items: [
      "Player join screen: fixed brain background URL (correct Firebase Storage bucket); image now loads in the iOS app.",
    ],
  },
  {
    version: "2.0.438",
    date: "2026-05-27",
    items: [
      "Player join screen: brain background uses a direct Firebase Storage URL (no async fetch) so it shows immediately in the Capacitor app.",
      "Player team-name and reconnect screens use the same brain background.",
      "iOS test refresh: `cap copy` plus `xcodebuild` and `simctl install` so the simulator picks up new JS bundles.",
    ],
  },
  {
    version: "2.0.437",
    date: "2026-05-27",
    items: [
      "Cursor rule: after player-app code changes, agent rebuilds mobile bundle, syncs to iOS, and relaunches the simulator test app automatically.",
    ],
  },
  {
    version: "2.0.436",
    date: "2026-05-27",
    items: [
      "Player join screen: replaced plain light-blue background with the brain background used on the host home screen.",
    ],
  },
  {
    version: "2.0.435",
    date: "2026-05-26",
    items: [
      "Player (web + mobile): free-text answers no longer show a redundant “You submitted: …” line — the input already shows your answer; Correct/Incorrect feedback is unchanged.",
    ],
  },
  {
    version: "2.0.434",
    date: "2026-05-26",
    items: [
      "Player lobby: “Optimize Your Phone” tips show for PWA (Add to Home Screen) only — hidden in the native Capacitor app.",
      "Extracted `PhoneSetupTipsCard` and `shouldShowPhoneSetupTips()` (`playerEnvironment.js`) so both lobby waiting states stay in sync.",
    ],
  },
  {
    version: "2.0.433",
    date: "2026-05-26",
    items: [
      "Player (web + mobile): team name field no longer spell-checks or autocorrects — creative team names stay as typed.",
    ],
  },
  {
    version: "2.0.432",
    date: "2026-05-26",
    items: [
      "Player join screen (native app): shows `Player app v<version> · <build date>` footer so you can confirm which web bundle is installed on the phone.",
    ],
  },
  {
    version: "2.0.431",
    date: "2026-05-26",
    items: [
      "Player: True/False answer pills now match multiple-choice height — uses `normalizeType` (CAT/TRUEFALSE), `player-answer-list--compact`, and inline row height so flex stretch cannot override on phones.",
    ],
  },
  {
    version: "2.0.430",
    date: "2026-05-26",
    items: [
      "Player (web + mobile): True/False answer pills use the same height as multiple-choice options (`player-answer-list--two-up`) instead of stretching to half the screen.",
    ],
  },
  {
    version: "2.0.422",
    date: "2026-04-30",
    items: [
      "Player (web + mobile): multi-choice, true/false, and bet-answer phases keep auto-submit on each pick but you can switch to another option until the timer ends; each selection overwrites the saved answer.",
      "Vanishing choice: each tap overwrites Firestore with the latest choice, visible-option count, and timestamps; changing is only allowed while your current selection is still on the board—once your pick ghosts, inputs lock as before.",
      "Reconnect: restore selections from Firestore by mapping stored canonical indices back to display order (including multi-answer checkbox indices).",
    ],
  },
  {
    version: "2.0.421",
    date: "2026-04-30",
    items: [
      "Agent workflow: new Cursor rule and npm scripts for backups under `QuizSoftware\\QuizmasterBobJune26-incremental-backups` — `npm run backup-incremental -- <paths>` before editing listed files; `npm run backup-full` for a tree copy excluding `node_modules`, `.git`, `build`, `Pods`, `.gradle`. Optional env `QUIZMASTER_INCREMENTAL_BACKUP_ROOT` overrides the folder.",
      "Initial full backup created on disk for this release (timestamped `full_backup_*` folder).",
    ],
  },
  {
    version: "2.0.420",
    date: "2026-04-30",
    items: [
      "CSV quiz editor column resize: removed fixed table layout and per-cell width locks so the grid matches the previous automatic layout; only header cells carry draggable widths (defaults unchanged: Q 460px, others 180px).",
    ],
  },
  {
    version: "2.0.419",
    date: "2026-04-30",
    items: [
      "CSV quiz editor (Trove): drag the right edge of any column header to resize columns horizontally (col-resize cursor). QUESTION/TITLE defaults wide (460px) with a higher max width; other columns default at 180px. Table uses fixed layout so header and row widths stay aligned.",
    ],
  },
  {
    version: "2.0.416",
    date: "2026-04-29",
    items: [
      "Trove hashtag preview: if the Firestore composite index for tags-only mode is not deployed yet, fall back to an unordered fetch (up to 500 unflagged rows) instead of failing with zero questions. Dedupe requested tags for matching; fixed Bob modal text duplicating the first hashtag when using a single tag like `#MilitaryHistory`.",
    ],
  },
  {
    version: "2.0.415",
    date: "2026-04-29",
    items: [
      "Trove CSV hashtag preview (tag-only placeholders like `#MilitaryHistory` without a genre hashtag): fetches unflagged questions in batches ordered by interest rating instead of a single arbitrary page of 100 docs, so the Ready list aligns much better with Library Viewer for the same tag. Added `firestore.indexes.json` (questionType + accuracyFlag + interestRating) and wired Firestore rules/indexes in `firebase.json`; deploy indexes so the new query works in production.",
    ],
  },
  {
    version: "2.0.414",
    date: "2026-04-29",
    items: [
      "Added venue Red Truck Farm to host options (Quiz options), Library Viewer filters, and Trove CSV hashtag preview venue dropdown; preview list now maps from the shared `venueOptions` array.",
    ],
  },
  {
    version: "2.0.413",
    date: "2026-04-27",
    items: [
      "Trove (CSV editor): the table header row (Copy / preview / flag / delete / drag / Q# / all CSV column titles) is sticky inside the scroll area so it stays visible while scrolling long quizzes. Table uses `border-collapse: separate` + `border-spacing: 0` so sticky headers behave reliably in the browser.",
    ],
  },
  {
    version: "2.0.412",
    date: "2026-04-27",
    items: [
      "Trove (CSV editor): reverted the Question (Q) column blackout from 2.0.411. Only the main media fields are blacked for slide rows: P1, P1_URL, and VIDEO_URL for INTRODUCTION, JOIN QUIZ, END QUIZ, BREAK TIME (unchanged), and now also SHOWROUNDS, STARTROUND, and ENDROUND. SOUND and background cells are unchanged.",
    ],
  },
  {
    version: "2.0.410",
    date: "2026-04-27",
    items: [
      "Trove / CSV — Out of Order preview pills: removed full-width stretch (inline width:100% on rows was overriding `.host-answer-item`’s clamp). Pills are again the usual width (centered, same as other multi-answer previews). BREADCRUMBS-only full-width column behavior unchanged.",
    ],
  },
  {
    version: "2.0.409",
    date: "2026-04-27",
    items: [
      "Trove / CSV — Out of Order preview: drag handle ☰ and rank numbers sit on the colored pills (layout matches BREADCRUMBS: fixed pill height, badge on the right, handle + number + text in one row). Answer column uses full width like Breadcrumbs.",
    ],
  },
  {
    version: "2.0.408",
    date: "2026-04-27",
    items: [
      "Trove / CSV question preview (hashtag & grid edit modal): Out of Order now shows rank numbers 1…n, a ☰ drag handle, and the same green/red pill badges as before. Drag reorders the option texts across A1–A6. (Earlier work was only in Library Viewer, not this preview.)",
    ],
  },
  {
    version: "2.0.407",
    date: "2026-04-27",
    items: [
      "Library Viewer — Out of Order: answer rows are numbered 1…n, draggable with a ☰ handle (same idea as Breadcrumb clue reorder in the CSV editor). Reordering rewrites A1…A6 values in the new order; ✓/✗ and green/red styling for first vs other slots are unchanged.",
    ],
  },
  {
    version: "2.0.406",
    date: "2026-04-27",
    items: [
      "CSV editor: OUT OF ORDER rows now black out P1 / P1_URL like WHEEL and BREADCRUMBS, with the label “MEDIA disabled for OUT OF ORDER”. BREADCRUMBS and WHEEL keep their existing messages.",
      "Switching a row to OUT OF ORDER clears P1 and P1_URL. Preview no longer uses a side image for WHEEL, BREADCRUMBS, or OUT OF ORDER.",
    ],
  },
  {
    version: "2.0.405",
    date: "2026-04-27",
    items: [
      "Breadcrumbs typing flow hardened: no parent draft sync/commit runs on each keypress in clue inputs anymore. Keystrokes stay local while focused, with commit only on blur (or Enter), preventing focus jumps after single-character edits.",
    ],
  },
  {
    version: "2.0.404",
    date: "2026-04-27",
    items: [
      "Breadcrumbs input focus retention fixed: external draft-sync no longer overwrites the local typing buffer while a clue field is focused, so cursor/focus now stays in the active pill across consecutive keypresses.",
    ],
  },
  {
    version: "2.0.403",
    date: "2026-04-27",
    items: [
      "Breadcrumbs clue/answer input now uses a local fast-edit buffer and debounced draft commit, so each key press appears immediately without waiting for full popup/table rerenders; blur still flushes instantly.",
    ],
  },
  {
    version: "2.0.402",
    date: "2026-04-27",
    items: [
      "CSV edit typing responsiveness improved: expensive preview fit recalculation no longer runs on every A1–A11 keystroke, so editing Breadcrumb/answer fields stays smooth while still resizing on type/footer/layout changes.",
    ],
  },
  {
    version: "2.0.401",
    date: "2026-04-27",
    items: [
      "Breadcrumbs CSV edit popup now uses the same near-full-screen modal height as other question types (fixed to the 95vh frame), so it no longer appears as a smaller/shrunken window on open.",
    ],
  },
  {
    version: "2.0.400",
    date: "2026-04-27",
    items: [
      "Breadcrumbs editor sizing no longer collapses clue rows to tiny strips: minimum row height in the scroll-region fit is raised, so the popup keeps normal visual scale like other question types instead of looking miniaturized.",
    ],
  },
  {
    version: "2.0.399",
    date: "2026-04-27",
    items: [
      "Breadcrumbs popup sizing now always allocates for all fixed slots (A1 + A2–A11), not just non-empty clues, so every Breadcrumb question keeps the same full layout instead of collapsing when fewer clue fields are filled.",
    ],
  },
  {
    version: "2.0.398",
    date: "2026-04-27",
    items: [
      "CSV / preview: Breadcrumb questions stored as “BRE” (short type) are now treated the same as “BREADCRUMBS” everywhere in the editor—full-width preview, P1 hidden, 11-answer path, and media cell blackout—so a row is no longer laid out like a different question type just because the tag text differed.",
    ],
  },
  {
    version: "2.0.397",
    date: "2026-04-27",
    items: [
      "CSV editor: P1 / P1_URL media is disabled for BREADCRUMBS the same way as for WHEEL (blackout cells + “MEDIA disabled for BREADCRUMBS” text).",
      "Switching a row’s type to BREADCRUMBS clears P1 and P1_URL. The Breadcrumbs question preview no longer reserves space for a side image even if old data had a URL.",
    ],
  },
  {
    version: "2.0.396",
    date: "2026-04-27",
    items: [
      "Breadcrumbs edit: when a question has a P1 image, the answer column no longer uses flex-end cross-alignment (which shrank the pill list to a narrow strip). Breadcrumb lists now stretch to the full width of that column; inner lists and rows use width 100% / minWidth 0 so pills stay readable beside the media column.",
    ],
  },
  {
    version: "2.0.395",
    date: "2026-04-27",
    items: [
      "Breadcrumbs CSV edit: clues (A2–A11) can be drag-reordered with a ☰ handle (same idiom as the main question table). Order maps to A2=first revealed … A11; numbers 1–10 show the reveal order next to the handle.",
    ],
  },
  {
    version: "2.0.394",
    date: "2026-04-27",
    items: [
      "Breadcrumbs CSV edit modal: main body scrolls in a flex column while the visible explanation, notes, and media block sit in normal flow below—so on 1366×768-style screens the footer no longer covers the clue pills.",
      "Breadcrumb clue placeholders use “Clue – …” with a one-word difficulty ramp (first revealed = hardest, last = lightest); correct answer placeholder is “Correct answer”.",
      "Tighter minimum pill height and font scaling when the scroll region is short so rows stay usable without overlapping the footer.",
    ],
  },
  {
    version: "2.0.393",
    date: "2026-04-26",
    items: [
      "Breadcrumbs popup fit rebalanced: clue rows now dynamically fill available height with readable bounds (20–42px), with adaptive row gaps and badge/text sizing tied to computed row height instead of a tiny fixed compact mode.",
    ],
  },
  {
    version: "2.0.392",
    date: "2026-04-26",
    items: [
      "Breadcrumbs popup fit tightened further for short/wide windows: clue list now uses an explicit row-height cap (14–24px), tighter inter-row gap, and smaller badge glyphs so A1–A11 stays above the fixed footer controls.",
      "Breadcrumbs sizing now measures from the actual clue `<ol>` block (not its parent container), and applies explicit pixel heights to each pill for deterministic rendering.",
    ],
  },
  {
    version: "2.0.391",
    date: "2026-04-26",
    items: [
      "Breadcrumbs edit popup: pill height is derived from the real viewport span between the answer column and the fixed footer (getBoundingClientRect), so short/wide aspect screens no longer get clues covered by the yellow bar or MP3/Spotify block.",
      "Breadcrumbs: answer column is top-aligned (flex-start) so the measure ref matches where the pill stack starts; a delayed re-measure handles notes/MP3 layout settling.",
    ],
  },
  {
    version: "2.0.390",
    date: "2026-04-26",
    items: [
      "Breadcrumbs popup layout now measures the actual bottom footer (visible explanation + notes + media controls) and dynamically sizes clue rows from remaining space, preventing overlap on shorter/common aspect-ratio screens.",
      "Breadcrumb clue text size now also responds to computed row height, so all A1-A11 pills remain readable while fitting above the footer without manual window stretching.",
    ],
  },
  {
    version: "2.0.389",
    date: "2026-04-26",
    items: [
      "Breadcrumbs quiz-edit preview: clue rows (A1–A11) use compact pill height, smaller text, and tighter spacing so all options fit above the visible-explanation bar without overlapping it; list no longer clips at 50vh for this type.",
    ],
  },
  {
    version: "2.0.388",
    date: "2026-04-26",
    items: [
      "Quiz edit popup now supports full Breadcrumbs clue editing/presentation through A11 (A1 correct answer + A2-A11 clue slots) instead of truncating at A6.",
      "Dynamic preview question sync/save and unsaved-change tracking now include A7-A11 so extra Breadcrumb clues persist consistently.",
    ],
  },
  {
    version: "2.0.381",
    date: "2026-04-23",
    items: [
      "Hashtag statistics: heavy aggregation runs in requestIdleCallback (non-blocking open); only 80 tag rows mount per page with Prev/Next; filter box to narrow tags (e.g. waylon); one pass builds tag rows + question text map.",
    ],
  },
  {
    version: "2.0.380",
    date: "2026-04-23",
    items: [
      "Hashtag statistics: questions for a tag open in one panel below the table (not an extra table row), avoiding full-table reflow and huge tbody reconciliation; hashtag modal only mounts while open so it does no work when closed.",
    ],
  },
  {
    version: "2.0.379",
    date: "2026-04-23",
    items: [
      "Hashtag statistics: while the modal is open the library list is frozen to a snapshot taken at open time so later `questions` updates (e.g. usage history merges) no longer re-run full tag aggregation and map rebuilds in the background; removed startTransition and content-visibility from that flow.",
    ],
  },
  {
    version: "2.0.378",
    date: "2026-04-23",
    items: [
      "Hashtag statistics: expanding a tag no longer re-renders every hashtag row (memoized table rows + stable toggle handler); expand/sort updates use startTransition; removed per-expand full-text sort (questions listed in id order); content-visibility on rows to lighten layout for huge tag lists.",
    ],
  },
  {
    version: "2.0.377",
    date: "2026-04-23",
    items: [
      "Library Viewer → Hashtag statistics: fixed expand freeze / memory pressure by storing only question ids per tag (not duplicated full text), memoizing the modal so parent re-renders do not rebuild the table, stable close handler, and paging expanded lists (200 at a time + Load more).",
    ],
  },
  {
    version: "2.0.376",
    date: "2026-04-23",
    items: [
      "Library Viewer → Hashtag statistics: default sort is count (descending); column headers are clickable to sort (tag, count, avg interest, predominant genre, category) and toggle ascending/descending.",
    ],
  },
  {
    version: "2.0.375",
    date: "2026-04-23",
    items: [
      "Library Viewer → Settings: Close moved to the header next to Reset to Defaults.",
      "Settings: “Hashtag stats…” after the hashtag filter opens a modal listing all tags (avg interest rating descending, count, predominant genre & category); expand a tag to see question text only.",
    ],
  },
  {
    version: "2.0.366",
    date: "2026-04-20",
    items: [
      "Player phones: answer choices no longer appear early when a question is loaded from the library (placeholder) path — `answersGateQ` is only opened from the host Quizscreen after the hero/TTS intro, matching normal advance and the big screen.",
    ],
  },
  {
    version: "2.0.365",
    date: "2026-04-20",
    items: [
      "Team round tag UI: removed the redundant “Round tag choice” label on host (TeamRoundChoiceGate) and on player screens; “Please select the next round:” + team name and the rest of the flow are unchanged.",
    ],
  },
  {
    version: "2.0.364",
    date: "2026-04-20",
    items: [
      "Team round tag reveal: legacy stored value of 3 seconds (old default in game settings / localStorage) is normalized to 7 so the post-pick pause matches the current default without re-saving Quiz Options.",
    ],
  },
  {
    version: "2.0.363",
    date: "2026-04-19",
    items: [
      "Round tag choice: host and player overlays use tight top padding, “Please select the next round:” with large team name, then countdown and options (less blank space above the timer).",
      "Player: removed non-lobby “Waiting for host…” placeholder when the answers gate is closed so it no longer leaves a gap during STARTROUND / team choice.",
    ],
  },
  {
    version: "2.0.362",
    date: "2026-04-18",
    items: [
      "Team round tag reveal: default pause after a pick is 7 seconds (Quiz Options → Reveal pause); host shows chosen pill with green correct halo, others ghosted; phones keep the same overlay through revealPause with countdown and “Selected for this round”.",
    ],
  },
  {
    version: "2.0.361",
    date: "2026-04-18",
    items: [
      "Host / projector (TeamRoundChoiceGate): round tag options show as the same large MCQ-style pills as on phones so the whole room can read them; chosen tag gets the selected outline during the reveal pause.",
    ],
  },
  {
    version: "2.0.360",
    date: "2026-04-18",
    items: [
      "Team round tag choice (player): hashtag options use the same elliptical multiple-choice pill styling as normal answers (player-answer-list / player-option-a–f).",
      "Round-tag chooser RNG never picks simulator / test-data NPC teams (names from TestDataGenerator testTeams); only real joined teams are eligible, in test and live.",
    ],
  },
  {
    version: "2.0.359",
    date: "2026-04-17",
    items: [
      "Team round tag choice: when a #TeamChoice STARTROUND appears before any ENDROUND (e.g. first round), the host reaching that slide now schedules a random eligible team (fair-share / random behavior matches tie logic).",
      "After ENDROUND, if no team answered the last scored question in the round, the chooser is picked at random from joined teams instead of skipping scheduling.",
    ],
  },
  {
    version: "2.0.358",
    date: "2026-04-17",
    items: [
      "advance(): STARTROUND and other display/slide CATs no longer treat leading # in Q as a QuestionLibrary placeholder — fixes #TeamChoice rounds being replaced by “No unused question” and restores team tag picker flow.",
    ],
  },
  {
    version: "2.0.357",
    date: "2026-04-17",
    items: [
      "CSV editor: default NOTES for STARTROUND rows explain team round tag choice (#TeamChoice / #PlayerChoice, optional #Genre, Quiz Options, placeholders).",
    ],
  },
  {
    version: "2.0.356",
    date: "2026-04-17",
    items: [
      "Team round tag choice: optional #TeamChoice / #PlayerChoice on STARTROUND; losing team (from last answered question in the round) picks a library hashtag on phones; Quizscreen mirrors countdown; placeholder questions merge the chosen tag; tag-pool preflight and CSV warnings in host UI; settings under Quiz Options and synced to game settings; Firestore games/{id}/roundTagChoice/session.",
    ],
  },
  {
    version: "2.0.353",
    date: "2026-04-14",
    items: [
      "Breadcrumbs two-per-genre clues: one fact per cell, 50–90 characters; generator enforces length and smarter Answer leak check.",
    ],
  },
  {
    version: "2.0.352",
    date: "2026-04-14",
    items: [
      "Breadcrumbs library CSV: clues ordered hard→easy; A11 no longer repeats Answer text; generator asserts no clue contains the full Answer string.",
    ],
  },
  {
    version: "2.0.351",
    date: "2026-04-14",
    items: [
      "library-upload-two-per-genre.csv: BREADCRUMBS with full A2–A11 clue ladders; clues data in scripts/two-per-genre-breadcrumb-clues.js.",
    ],
  },
  {
    version: "2.0.348",
    date: "2026-04-13",
    items: [
      "Added library-upload-two-per-genre.csv: two TYPE questions per Library Viewer genre (19 genres) with vague prompts; optional generator script under scripts/.",
    ],
  },
  {
    version: "2.0.347",
    date: "2026-04-13",
    items: [
      "Sample breadcrumbs geography CSV: INTEREST_RATING and Difficulty set on 1–99 scale with matching justification text.",
    ],
  },
  {
    version: "2.0.346",
    date: "2026-04-13",
    items: [
      "Sample library CSV: BREADCRUMBS clues reordered hardest-to-easiest (A2–A11); updated interest and difficulty fields per question.",
    ],
  },
  {
    version: "2.0.345",
    date: "2026-04-13",
    items: [
      "Question Library CSV upload: map A7–A11 into Firestore so BREADCRUMBS clues round-trip.",
      "Added breadcrumbs-geography-library-upload.csv sample (three BREADCRUMBS geography questions) matching Upload to Library headers.",
    ],
  },
  {
    version: "2.0.344",
    date: "2026-04-13",
    items: [
      "About: added a change log section listing recent releases.",
      "Routing: /About now resolves to the same page as /about.",
      "Cursor: added project rule to bump version and record changes here after work.",
    ],
  },
];
